import React, { Component } from 'react';
import { bisectRight, forceSimulation, forceX, forceY } from 'd3';
import forceManyBody from './myManyBody';

import './Canvas.css';

class Canvas extends Component {

  componentDidMount() {
    const canvas = this.node,
          context = canvas.getContext("2d"),
          { radius, nodes, targetPoints, getColor, targets } = this.props;

    this.nodes = nodes;

    this.nodes.forEach(d => {
      d.targetIndex = d.target[bisectRight(d.time, this.props.time) - 1] - 1;
      d.targetX = targetPoints[d.targetIndex][0];
      d.targetY = targetPoints[d.targetIndex][1];
      d.x = d.targetX;
      d.y = d.targetY;
      d.color = 'gray';
    });

    this.getColor = getColor;

    const ticked = () => {
      context.clearRect(0, 0, this.props.width, this.props.height);
      context.save();
      for (const d of this.nodes) {
        context.beginPath();
        context.arc(d.x, d.y, radius, 0, 2 * Math.PI);
        context.fillStyle = this.getColor(d);
        context.strokeStyle = this.getColor(d);
        context.fill();
      }
      context.restore();
    }

    this.simulation = forceSimulation(this.nodes)
      .force("x", forceX(this.forceX).strength(0.05))
      .force("y", forceY(d => d.targetY).strength(0.05))
      .alphaDecay(0.002)
      .velocityDecay(0.38)
      .on("tick", ticked);

    targets.forEach((_, i) => {
      this.simulation.force('charge-' + i,
        forceManyBody().filter(d => d.targetIndex === i).strength(-0.7));
    });
  }

  forceX = d => d.targetX;
  forceXSex = d => d.INC1 === 2 ? d.targetX - 5: d.targetX + 5;

  componentDidUpdate() {
    this.simulation.stop();
    this.nodes = this.nodes.map((d, i) => {
      const time = this.props.nodes[i].time,
            target = this.props.nodes[i].target;

      const timeIndex = bisectRight(time, (this.props.time + 20 * 60) % 1440) - 1,
            targetIndex = target[timeIndex] - 1;
      return {
          ...d,
          targetIndex,
          time,
          target,
          targetX: this.props.targetPoints[targetIndex][0],
          targetY: this.props.targetPoints[targetIndex][1]
      }
    });
    this.getColor = this.props.getColor;
    this.simulation.nodes(this.nodes);
    this.simulation.force("x").x(this.props.bySex ? this.forceXSex : this.forceX);
    this.simulation.alphaDecay(this.props.bySex ? 0.002 : 0.001);
    this.simulation.alpha(1).restart();
  }

  getLabelStyle = i => this.props.targetPoints ?
    { top: this.props.targetPoints[i][1] +'px', left: this.props.targetPoints[i][0] +'px'} :
    {};

  render() {
    const { targets, id, width, height, time, nodes, numFormat } = this.props;
    const shares = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    nodes.forEach(e => {
      const timeIndex = bisectRight(e.time, (time + 20 * 60) % 1440) - 1,
            targetIndex = e.target[timeIndex] - 1;
      shares[targetIndex]++;
    });
    return (
      <div id={id} className="graph">
        <canvas ref={ node => this.node = node}
          width={width}
          height={height}></canvas>
        {
          targets.map((e, i) =>
            <div style={{display: 'table'}} key={i}>
              <div className="label"
                style={this.getLabelStyle(i)}>{e} <br /> {numFormat(shares[i] / 10)}%</div>
            </div>
          )
        }
      </div>
    )
  }
}

export default Canvas;


// WEBPACK FOOTER //
// ./src/canvas.js